import enLang from './entries/en_US';
import zhLang from './entries/zh_CN';
import frLang from './entries/fr_FR';
import jaLang from './entries/ja_JP';
import roLang from './entries/ro_RO';

const AppLocale = {
    en: enLang,
    ro: roLang,
    zh: zhLang,
    fr: frLang,
    ja: jaLang
};

export default AppLocale;